import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana44Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_25060)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("25"))}
        d="M715.196 679.201L756.256 656.576L713.52 644.845L704.303 675.849L715.196 679.201Z"
        fill={getFillByLot(25, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("24"))}
        d="M788.939 640.654L756.258 656.575L748.717 654.061L757.096 621.381L789.777 629.76C793.129 634.453 790.615 638.978 788.939 640.654Z"
        fill={getFillByLot(24, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("23"))}
        d="M731.96 614.678L757.098 621.381L748.719 654.062L723.58 647.358L731.96 614.678Z"
        fill={getFillByLot(23, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("22"))}
        d="M707.657 607.974L731.958 614.677L723.578 647.358L698.439 639.816L707.657 607.974Z"
        fill={getFillByLot(22, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("26"))}
        d="M678.324 668.306L704.301 675.848L713.519 644.843L688.38 637.302L678.324 668.306Z"
        fill={getFillByLot(26, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("21"))}
        d="M682.513 600.433L707.651 607.974L698.434 639.817L672.457 632.275L682.513 600.433Z"
        fill={getFillByLot(21, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("27"))}
        d="M652.352 659.926L678.328 668.306L688.384 637.301L663.245 628.922L652.352 659.926Z"
        fill={getFillByLot(27, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("20"))}
        d="M657.378 592.89L682.517 600.431L672.461 632.274L647.322 623.894L657.378 592.89Z"
        fill={getFillByLot(20, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("28"))}
        d="M627.209 651.548L652.348 659.928L663.241 628.924L638.102 620.544L627.209 651.548Z"
        fill={getFillByLot(28, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("19"))}
        d="M632.243 584.512L657.382 592.891L647.326 623.896L622.188 614.678L632.243 584.512Z"
        fill={getFillByLot(19, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("29"))}
        d="M602.072 643.168L627.211 651.547L638.105 620.543L613.804 612.163L602.072 643.168Z"
        fill={getFillByLot(29, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("18"))}
        d="M608.776 576.13L632.239 584.509L622.184 614.676L597.883 606.296L608.776 576.13Z"
        fill={getFillByLot(18, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("30"))}
        d="M576.102 633.951L602.078 643.168L613.81 612.164L588.671 602.946L576.102 633.951Z"
        fill={getFillByLot(30, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        d="M584.47 566.913L608.771 576.131L597.877 606.297L572.738 597.08L584.47 566.913Z"
        fill={getFillByLot(17, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("31"))}
        d="M551.795 624.734L576.096 633.952L588.665 602.947L564.364 593.729L551.795 624.734Z"
        fill={getFillByLot(31, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("32"))}
        d="M527.49 614.678L551.791 624.734L564.36 593.729L540.898 584.512L527.49 614.678Z"
        fill={getFillByLot(32, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        d="M560.173 557.697L584.474 566.915L572.742 597.081L547.604 587.026L560.173 557.697Z"
        fill={getFillByLot(16, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        d="M535.876 547.642L560.177 557.697L547.607 587.026L523.307 576.97L535.876 547.642Z"
        fill={getFillByLot(15, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("33"))}
        d="M502.355 603.785L527.494 614.678L540.902 584.512L516.601 574.456L502.355 603.785Z"
        fill={getFillByLot(33, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        d="M511.575 537.585L535.876 547.64L523.307 576.969L499.006 566.914L511.575 537.585Z"
        fill={getFillByLot(14, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("34"))}
        d="M478.055 592.891L502.356 603.785L516.601 574.456L491.462 563.562L478.055 592.891Z"
        fill={getFillByLot(34, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        d="M488.946 526.692L511.571 537.586L499.002 566.914L474.701 555.183L488.946 526.692Z"
        fill={getFillByLot(13, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("35"))}
        d="M454.594 582.835L478.057 592.89L491.464 563.561L468.839 552.668L454.594 582.835Z"
        fill={getFillByLot(35, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M464.648 514.96L488.948 526.691L474.703 555.182L451.24 543.451L464.648 514.96Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("36"))}
        d="M429.451 571.104L454.59 582.835L468.835 552.669L445.372 540.938L429.451 571.104Z"
        fill={getFillByLot(36, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M441.187 503.229L464.65 514.961L451.242 543.452L426.941 531.72L441.187 503.229Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("37"))}
        d="M405.152 559.372L429.453 571.103L445.374 540.937L421.912 529.205L405.152 559.372Z"
        fill={getFillByLot(37, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("38"))}
        d="M381.691 546.803L405.154 559.373L421.913 529.206L398.451 516.637L381.691 546.803Z"
        fill={getFillByLot(38, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M418.564 491.497L441.189 503.229L426.943 531.719L404.318 519.15L418.564 491.497Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M395.095 478.929L418.558 491.498L404.312 519.151L380.85 506.581L395.095 478.929Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M373.308 466.357L395.095 478.927L380.85 506.579L357.387 493.172L373.308 466.357Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("40"))}
        d="M334.764 519.151L358.227 533.396L375.824 504.068L352.361 490.66L334.764 519.151Z"
        fill={getFillByLot(40, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("39"))}
        d="M358.232 533.395L381.695 546.802L398.454 515.798L375.83 504.066L358.232 533.395Z"
        fill={getFillByLot(39, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("41"))}
        d="M312.975 505.743L334.762 519.151L352.359 490.66L329.734 478.091L312.975 505.743Z"
        fill={getFillByLot(41, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M350.683 452.951L373.308 466.359L357.387 493.173L333.924 479.766L350.683 452.951Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M328.06 438.706L350.685 452.951L333.088 479.766L311.301 467.197L328.06 438.706Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("42"))}
        d="M289.512 491.498L312.975 505.744L329.734 478.091L307.109 464.684L289.512 491.498Z"
        fill={getFillByLot(42, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("43"))}
        d="M266.887 477.252L289.512 491.498L307.109 464.683L284.484 450.438L266.887 477.252Z"
        fill={getFillByLot(43, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M305.437 425.298L328.062 438.705L311.303 467.196L288.678 452.951L305.437 425.298Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M284.484 411.053L305.433 425.298L288.674 452.951L266.887 438.705L284.484 411.053Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("44"))}
        d="M245.102 462.169L266.889 477.252L284.486 450.438L262.699 436.192L245.102 462.169Z"
        fill={getFillByLot(44, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M262.699 396.808L284.486 411.053L266.889 438.706L245.102 423.622L262.699 396.808Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("45"))}
        d="M224.156 447.922L245.105 462.167L262.702 436.191L241.753 421.945L224.156 447.922Z"
        fill={getFillByLot(45, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M241.748 381.725L262.697 396.808L245.1 423.623L222.475 408.539L241.748 381.725Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("46"))}
        d="M200.689 432.002L224.152 447.923L241.749 421.947L219.963 406.863L200.689 432.002Z"
        fill={getFillByLot(46, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M227.504 370.831L241.749 381.724L222.476 408.539L203.203 394.294C204.879 392.618 210.745 382.562 214.097 374.183C216.778 367.479 224.152 369.155 227.504 370.831Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("47"))}
        d="M181.419 419.433L200.691 432.002L219.964 406.863L203.205 394.294C199.015 400.16 187.285 405.187 182.257 409.377C178.235 412.729 180.023 417.477 181.419 419.433Z"
        fill={getFillByLot(47, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_25060"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_25060"
            transform="matrix(0.0011494 0 0 0.0015238 -1.23429 -0.745008)"
          />
        </pattern>
        <image
          id="image0_1466_25060"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
